import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  columns,
  filters,
  searchBy,
} from "../../../service/AUPromocodeService";
import BasicTable from "../../../Components/CommonTable/BasicTable/BasicTable";
import { ApproveUnapproveApi } from "../../../App/api/a&uApi";
import CommonRejectTemplate from "../../../Components/CommonRejectTemplate";
import CustomModal from "../../../custom/modal/customModal";
import PromoSidebar from "./PromoSidebar";
import { approvalStatusApi } from "../../../App/api/multilevelApproval.api";
import { toast } from "react-toastify";

const AUPromocoderComponent = ({
  disabledFilters,
  pagination,
  handlePagination,
}) => {
  const [search, setSearch] = useState("");
  const debounceTimeout = useRef(null);

  const [selectedOrder, setSelectedOrder] = useState(null);
  const [promocodeData, setPromocodeData] = useState(null);
  const [isRejectPromoModalOpen, setIsRejectPromoModalOpen] = useState(false);
  const [actionData, setActionData] = useState(null);
  const [isOpenSidbar, setIsOpenSidbar] = useState(false);
  const [approvalStatus, setApprovalStatus] = useState(null);

  const getAllPromocode = async () => {
    try {
      const res = await ApproveUnapproveApi.getAllPromocodes(
        pagination,
        search
      );
      setPromocodeData(res?.data?.data);
    } catch (error) {
      toast.error(error?.message);
    }
    try {
      const approvalStatus = await approvalStatusApi.getAllApprovalStatuses({
        filter: { component: "PromoCode" },
      });
      setApprovalStatus(approvalStatus?.data?.data);
    } catch (error) {
      toast.error(error?.message);
    }
  };



  const handleCellClick = async (row, action) => {
    setSelectedOrder(row);
    setActionData(action);
    

    if (action === "Rejected") {
      setIsRejectPromoModalOpen(true);
    } else if (action === "Approved") {
      setIsOpenSidbar(true);
    }
  };

  const onPaginatorClick = (e) => {
    if (e) {
      const data = {
        limit: e.rows,
        page: +e.page + 1,
      };
      handlePagination && handlePagination(data);
    }
  };

  const handleSearch = useCallback((s) => {
    setSearch(s);
  }, []);

  const debouncedSearch = useCallback(
    (s) => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
      debounceTimeout.current = setTimeout(() => {
        handleSearch(s);
      }, 1500);
    },
    [handleSearch]
  );

  const handleClearFilter = () => {
    const clearPagination = {
      page: 1,
      limit: 5,
      sortOrder: "desc",
      filter: {},
    };
    handlePagination && handlePagination({ clearPagination });
  };
  const handleFilter = (name, value) => {
    let data = {};
    if (name === "search_by") {
      data.sortOrder = value.code;
    } else {
      const filter = {};
      filter[name] = value.code ? value.code : value;
      data.filter = filter;
    }

    handlePagination && handlePagination(data);
  };

  useEffect(() => {
    getAllPromocode();
  }, [pagination, search]);

  return (
    <div className="p-5">
      <BasicTable
        columns={columns}
        data={promocodeData?.promoCodes}
        onPaginatorClick={onPaginatorClick}
        paginatorData={{
          filters: null,
          first: 0,
          multiSortMeta: [],
          page: promocodeData?.limit || 5,
          sortField: null,
          sortOrder: null,
          totalPages: promocodeData?.totalPages || 1,
          totalCount: promocodeData?.totalCount || 1,
        }}
        onCellClick={(e) => {}}
        SearchBy={searchBy}
        handleSearch={debouncedSearch}
        handleFilter={(name, value) => handleFilter(name, value)}
        handleClearFilter={handleClearFilter}
        filters={filters}
        selectedData={selectedOrder}
        handleCellClick={handleCellClick}
      />
      <PromoSidebar
        data={selectedOrder}
        isOpen={isOpenSidbar}
        onClose={() => setIsOpenSidbar(false)}
        getAllPromocode={getAllPromocode}
        actionData={actionData}
        endPoint={approvalStatusApi.createApprovalStatus}
        getAllData={getAllPromocode}
        approvalStatus={approvalStatus}
        title="Promocode Approval"
      />

      <CustomModal
        isOpen={isRejectPromoModalOpen}
        onClose={() => setIsRejectPromoModalOpen(false)}
        title="Reject Promocode"
      >
        <CommonRejectTemplate
          data={selectedOrder}
          actionData={actionData}
          getAllData={getAllPromocode}
          endpoint={ApproveUnapproveApi.updatePromocodes}
          name={selectedOrder?.promo_code}
          closeModal={setIsRejectPromoModalOpen}
          component="PromoCode"
          approvalStatus={approvalStatus}
        />{" "}
      </CustomModal>
    </div>
  );
};

export default AUPromocoderComponent;
